import { useMemo } from "react";
import { POSITIONS } from "@besenliga/shared";
import { browserStore, loadRoster } from "../creator/roster";
import { CLUB_NAMES } from "../flight/pilot";

/** Menu principal (item 4.5): jogar, treinar, criar atleta e ver o estádio. */
export function MainMenu() {
  const roster = useMemo(() => loadRoster(browserStore()), []);
  const first = roster[0];
  return (
    <main className="menu-screen">
      <section className="menu-card" aria-labelledby="menu-titulo">
        <h1 id="menu-titulo" className="menu-logo">
          Besenliga
        </h1>
        <p className="menu-tagline">Esporte em vassouras, no seu navegador.</p>
        <nav className="menu-actions" aria-label="Menu principal">
          <a className="primary menu-main" href="#partida">
            Jogar partida
          </a>
          <a className="ghost" href="#voo">
            Treino livre
          </a>
          <a className="ghost" href="#criar">
            {first ? "Criar ou editar atletas" : "Criar seu atleta"}
          </a>
          <a className="ghost" href="#estadio">
            Ver o estádio
          </a>
        </nav>
        <p className="menu-athlete">
          {first ? (
            <>
              Em campo: <strong>{first.name}</strong> · {POSITIONS[first.position].label} ·{" "}
              {CLUB_NAMES[first.kit].full}
              {roster.length > 1 && ` (e mais ${roster.length - 1} no elenco)`}
            </>
          ) : (
            "Você ainda não criou um atleta: dá para jogar com o atleta de teste."
          )}
        </p>
      </section>
    </main>
  );
}
